import React from 'react';
import { motion } from 'framer-motion';

const CinematicText = ({ text, className = "", delay = 0, splitBy = "words" }) => {
  const items = splitBy === "chars" ? text.split("") : text.split(" ");

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: splitBy === "chars" ? 0.04 : 0.1, delayChildren: delay },
    },
  };

  const child = {
    visible: {
      opacity: 1, y: 0, filter: "blur(0px)",
      transition: { type: "spring", damping: 18, stiffness: 90 }
    },
    hidden: {
      opacity: 0, y: 40, filter: "blur(12px)",
      transition: { type: "spring", damping: 18, stiffness: 90 }
    },
  };

  return (
    <motion.div
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      className={`flex flex-wrap ${className}`}
    >
      {items.map((item, index) => (
        <motion.span
          variants={child}
          key={index}
          className={splitBy === "chars" ? "inline-block" : "mr-[0.28em] inline-block"}
        >
          {item === " " ? "\u00A0" : item}
        </motion.span>
      ))}
    </motion.div>
  );
};

export default CinematicText;